export enum NotificationTypeEnum {
  TaskCreated = 1,
  ContractorInTransit = 2,
  TaskScheduled = 3,
  TaskAssigned = 4,
  Rejected = 5,
  TaskFinished = 6,
  ContractorDelayed = 7,
  TaskUnAssigned = 8,
  TaskReschedule = 9,
  ContractorCreated = 10,
  UserCreated = 11,
  FormFinished = 12,
  AOChangedItem = 13,
  AOChangedQuantityItem = 14,
  AOAddedItem = 15,
  ManufacturingItemCreated = 16,
  UnpaidPaidLabor = 17,
  PreparedTask = 18,
  ServiceDay = 19,
  OneDayBefore = 20,
  ProductInTransit = 21,
  FiveDaysBefore = 22,
  BudgetCreated = 23,
}
